export const SEND_MAIL_REQUESTED = 'views/Home/SEND_MAIL_REQUESTED';
export const SEND_MAIL_SUCCESS = 'views/Home/SEND_MAIL_SUCCESS';
export const SEND_MAIL_FAILED = 'views/Home/SEND_MAIL_FAILED';
